// extracted by mini-css-extract-plugin
export var modal = "Modal-module--modal--hupZC";
export var modalBody = "Modal-module--modal-body--t1F46";
export var modalContent = "Modal-module--modal-content--5f0sS";
export var modalFooter = "Modal-module--modal-footer--kTXz7";
export var modalHeader = "Modal-module--modal-header--Dmwgw";
export var modalTitle = "Modal-module--modal-title--u4WuZ";